function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import get from 'lodash/get';
import map from 'lodash/map';
import isObject from 'lodash/isObject';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import times from 'lodash/times';
import isFunction from 'lodash/isFunction';
import Pagination from 'components/Pagination';
import * as shapes from './shapes';
var _React_Component;
class Table extends (_React_Component = React.Component) {
    componentDidMount() {
        this.onPageChange(this.props.page);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.page !== this.props.page || prevProps.totalEntities !== this.props.totalEntities || prevProps.entities.length !== this.props.entities.length) {
            this.onPageChange(this.props.page);
        }
    }
    async onPageChange(page) {
        const { perPage } = this.state;
        const { totalPages } = this;
        if (isNull(totalPages)) {
            return;
        }
        if (page >= totalPages || totalPages === 1) {
            page = 0;
        }
        if (page === this.state.page) {
            return;
        }
        if (this.props.onPageChange) {
            await this.props.onPageChange({
                page,
                perPage
            });
        }
        this.setState({
            page
        });
    }
    async onPerPageChange(perPage) {
        const { page } = this.state;
        if (this.props.onPerPageChange) await this.props.onPerPageChange({
            page,
            perPage
        });
        this.setState({
            perPage
        });
    }
    get pagedEntities() {
        const { entities, idKey, isInProgress, onPageChange, isOnPageChangeReturnOneSide } = this.props;
        const { page, perPage } = this.state;
        if (perPage === -1) return entities;
        if (isInProgress) {
            return times(perPage, (n)=>({
                    [idKey]: n
                }));
        }
        if (onPageChange && isOnPageChangeReturnOneSide) {
            return entities;
        }
        return entities.slice(perPage * page, perPage * (page + 1));
    }
    get totalPages() {
        const { perPage, entities, totalEntities } = this.props;
        const entitiesCount = isUndefined(totalEntities) ? entities.length : totalEntities;
        if (isNull(entitiesCount)) {
            return null;
        }
        return Math.ceil(entitiesCount / perPage);
    }
    renderHeaderCell(schemaItem, idx) {
        const { labelMessage = '', key, cellClassName, onClickHeader } = schemaItem;
        let message = null;
        if (isFunction(labelMessage)) {
            message = labelMessage();
        } else {
            message = isObject(labelMessage) ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, labelMessage)) : labelMessage;
        }
        return /*#__PURE__*/ _jsx("th", {
            className: cn('table__cell', `table__cell--${key}`, cellClassName),
            onClick: onClickHeader,
            children: message
        }, idx);
    }
    renderHeader() {
        if (this.props.isHeaderOff) return null;
        const { schema } = this.props;
        return /*#__PURE__*/ _jsx("thead", {
            className: "table__header",
            children: /*#__PURE__*/ _jsx("tr", {
                className: "table__row",
                children: map(schema, (schemaItem, idx)=>this.renderHeaderCell(schemaItem, idx))
            })
        });
    }
    renderRowCell(entity, entityKey, schemaItem) {
        const { key, cellClassName, renderer } = schemaItem;
        const value = renderer ? renderer(entity) : get(entity, key, '');
        return /*#__PURE__*/ _jsx("td", {
            className: cn('table__cell', `table__cell--${key}`, cellClassName),
            children: value
        }, `${entityKey}-${key}`);
    }
    renderRow(entity) {
        const { schema, idKey, isInProgress } = this.props;
        const entityKey = get(entity, idKey);
        return /*#__PURE__*/ _jsx("tr", {
            className: cn('table__row', {
                fadingLoader: isInProgress
            }),
            children: map(schema, (schemaItem)=>this.renderRowCell(entity, entityKey, schemaItem))
        }, entityKey);
    }
    renderBody() {
        return /*#__PURE__*/ _jsx("tbody", {
            children: map(this.pagedEntities, (entity)=>this.renderRow(entity))
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "table__wrapper",
                    children: /*#__PURE__*/ _jsxs("table", {
                        className: cn('table', this.props.className),
                        children: [
                            this.renderHeader(),
                            this.renderBody()
                        ]
                    })
                }),
                this.props.perPage !== -1 && /*#__PURE__*/ _jsx(Pagination, {
                    perPage: this.state.perPage,
                    onPerPageChange: (perPage)=>this.onPerPageChange(perPage),
                    onPageChange: (page)=>this.onPageChange(page),
                    page: this.state.page,
                    totalPages: this.totalPages,
                    isPerPageOff: this.props.isPerPageOff
                })
            ]
        });
    }
    constructor(props){
        super(props);
        const { page, perPage } = props;
        this.state = {
            page,
            perPage
        };
    }
}
_define_property(Table, "propTypes", {
    // Explicit props
    idKey: PropTypes.string.isRequired,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    schema: shapes.schema.isRequired,
    entities: PropTypes.array.isRequired,
    page: PropTypes.number,
    perPage: PropTypes.number,
    totalEntities: PropTypes.number,
    isInProgress: PropTypes.bool,
    isPerPageOff: PropTypes.bool,
    isHeaderOff: PropTypes.bool,
    isOnPageChangeReturnOneSide: PropTypes.bool,
    // Explicit actions
    onPageChange: PropTypes.func,
    onPerPageChange: PropTypes.func
});
_define_property(Table, "defaultProps", {
    page: 0,
    perPage: 10,
    isHeaderOff: false,
    isOnPageChangeReturnOneSide: false
});
export default Table;
